var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSemiDetachedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 86,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#5F5C60",
    strokeWidth: 1.385,
    d: "M62.677 79.798V35.576"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#5F5C60",
    strokeWidth: 1.385,
    strokeLinejoin: "round",
    d: "M2.612 84.544h118.161V79.7H2.612zM92.777 54.184h17.858V41.198H92.777v12.986zm0 19.495h17.858V60.693H92.777V73.68zM68.691 54.184h9.671V41.198h-9.671v12.986zm.16 25.057h9.511V60.768h-9.511v18.473zM37.935 54.184h17.857V41.198H37.935v12.986zm0 19.495h17.857V60.693H37.935V73.68zM14.009 54.184h9.509V41.198h-9.509v12.986zm0 25.057h9.509V60.768h-9.509v18.473zm-9.381.364h114.128v-44.19H4.628v44.19z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#5F5C60",
    strokeWidth: 1.385,
    strokeLinejoin: "round",
    d: "M122.693 35.454h-122L8.76 10.629h105.933z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5F5C60",
    d: "M1.153 33.689v-1.318h120.495v1.318"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#5F5C60",
    strokeWidth: 1.385,
    strokeLinejoin: "round",
    d: "M105.308 10.601h6.493V5.317h-6.493z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#5F5C60",
    strokeWidth: 1.089,
    strokeLinejoin: "round",
    d: "M104.683 5.431h7.743V.544h-7.743z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#5F5C60",
    strokeWidth: 1.385,
    strokeLinejoin: "round",
    d: "M56.613 10.601h6.493V5.317h-6.493z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#5F5C60",
    strokeWidth: 1.089,
    strokeLinejoin: "round",
    d: "M55.988 5.431h7.743V.544h-7.743z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#5F5C60",
    strokeWidth: 1.385,
    d: "M104.938 41.606l.079 12.485M104.938 61.248v11.831M50.272 41.606l.045 12.37M13.69 44.667h10.384M68.297 44.667h10.384M50.272 60.903l.045 12.369"
  }))));
}

export default SvgSemiDetachedIcon;